<mat-form-field appearance="fill" class="width-100">
  <mat-label>{{label | translate}}</mat-label>
  <input matInput class="input" [disabled]="mode != Mode.edition" [matDatepicker]="picker" [max]="before" [required]="required"
    [(ngModel)]="date" (dateChange)="onDate()">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
